exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/service_ticket_parts/edit/service_ticket_parts.edit.scss
// module id = 1091
// module chunks = 1